// @ts-strict-ignore
import { useSnackBar } from '@usealloy/component-library';
import React, { createContext, useMemo, useContext } from 'react';
import createAPIClient from './apiClient';
import { UserContext } from '~/dashboard/context';
import createModuleAPIs from './modules';
import type { API } from './modules';


export const APIContext = createContext<API>(null);
export function APIProvider({ children }: { children: React.ReactNode }) {
  const { typhonDomain } = useContext(UserContext);
  const addSnackbar = useSnackBar();

  const apiClient = useMemo(() => createAPIClient({
    baseURL: typhonDomain,
    showErrorMessage: m => addSnackbar({ title: m, type: 'danger', duration: 3_000 }),
  }), [addSnackbar, typhonDomain]);

  const modules = useMemo(() => createModuleAPIs(apiClient), [apiClient]);

  return (
    <APIContext.Provider value={modules}>
      {children}
    </APIContext.Provider>
  );
}

export default function useAPI() {
  const ctx = useContext(APIContext);
  if (!ctx) {
    throw new Error('useAPI() can only be used inside of an APIContext wrapper');
  }
  return ctx;
}
